<div class="navbar-container-links flex" id="mach-core-header-nav-links">
  <ul
    [ngClass]="{
      'laptop:gap-[160px] ultrawide:gap-[160px] max-[1280px]:!gap-[22px]':
        isLoggedIn && isBusinessAccount,
      'laptop:gap-[104px] ultrawide:gap-[252px]':
        isLoggedIn && !isBusinessAccount,
      'laptop:gap-[35px] ultrawide:gap-[199px]': !isLoggedIn
    }"
    class="navbar-container-links--list flex whitespace-nowrap pt-[8px] laptop:min-h-[47px]"
    id="mach-core-header-nav-primary-list"
    itemscope
    role="tablist"
  >
    <!-- Primary Navigation -->

    <div class="flex tablet:gap-16 ultrawide:gap-[24px]">
      <li
        *ngFor="let navItem of content.primary; let i = index"
        role="none"
        class="navbar-item text-label-xs-semibold py-[4px] max-[1280px]:!text-[12px]"
        itemprop="name"
        [id]="'mach-core-header-nav-primary-' + i"
      >
        <a
          role="tab"
          [attr.aria-selected]="selectedNav === navItem.id"
          [attr.id]="'headPrimary' + (i + 1)"
          [attr.aria-controls]="'tab-' + (i + 1)"
          [attr.tabindex]="selectedNav === navItem.id || inMobile ? '0' : '-1'"
          class="navbar-item !text-inverse text-label-xs-semibold no-underline max-[1280px]:!text-[12px]"
          href="javascript:void(0);"
          itemprop="url"
          (click)="
            onTrackingObject(navItem.id);
            onPrimaryNavClick(
              navItem.id,
              navItem.details.legacyAppUrl,
              navItem.redirectMobile,
              navItem.redirectMobileUrl
            )
          "
          (focus)="selectedSecNav = null"
          (keydown)="onKeyEvent($event)"
        >
          {{ navItem.label }}
        </a>
        <aside
          *ngIf="selectedNav === navItem.id && !isSlimHeader"
          class="bg-button-primary flex items-center justify-center rounded-full h-[4px] mt-[10px]"
        ></aside>
      </li>
    </div>

    <!-- Secondary Navigation -->
    <div class="flex tablet:gap-16 ultrawide:gap-[24px] secondary-nav">
      <li
        *ngFor="let secNavItem of content.secondary; let i = index"
        role="none"
        [ngClass]="{
          'first-static-link': i === 0,
          'last-static-link': i === 2
        }"
        class="navbar-item text-label-xs-medium py-[4px] max-[1280px]:!text-[11px]"
        dropdown
        [id]="'mach-core-header-nav-secondary-' + i"
      >
        <a
          role="tab"
          [attr.aria-selected]="selectedSecNav === secNavItem.id"
          [attr.id]="'headSectab' + (i + 1)"
          [attr.tabindex]="
            selectedSecNav === secNavItem.id || inMobile ? '0' : '-1'
          "
          class="navbar-item--link !text-inverse text-label-xs-medium max-[1280px]:!text-[11px]"
          href="javascript:void(0);"
          (click)="onTrackingObject(secNavItem.id, secNavItem.label)"
          (keydown)="onKeyEvent($event)"
          (mouseout)="onSecondaryNavAction('mouseout')"
          (mouseover)="onSecondaryNavAction('mouseover', secNavItem.id)"
        >
          {{ secNavItem.label }}
        </a>

        <aside
          *ngIf="selectedSecNav === secNavItem.id"
          class="bg-button-primary flex items-center justify-center rounded-full h-[4px] mt-[10px]"
        ></aside>
      </li>
    </div>
  </ul>
</div>
